(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dzubi-wholesale"] && !Shopify.designMode) return;
  try {
    
function initDzubiInquiries() {
  document.querySelectorAll('[data-dzubi-inquiry]').forEach(root => {
    if (root.dataset.inquiryReady || !root.querySelector('[data-inquiry-strings]')) return;
    root.dataset.inquiryReady = 'true';
    const strings = JSON.parse(root.querySelector('[data-inquiry-strings]').textContent);
    const items = new Map();
    const list = root.querySelector('[data-inquiry-list]');
    const summary = root.querySelector('[data-inquiry-summary]');
    const send = root.querySelector('[data-inquiry-send]');
    const status = root.querySelector('[data-inquiry-status]');
    const form = root.querySelector('.dzubi-inquiry-form');
    const whole = value => Number.isSafeInteger(Number(value)) && Number(value) >= 0;
    function render(focusId) {
      list.replaceChildren();
      let total = 0;
      const lines = [];
      items.forEach((item, id) => {
        total += item.qty;
        const url = new URL(item.url, location.origin); url.search = ''; url.hash = '';
        lines.push(item.title + ' | ' + item.size + ' | Qty: ' + item.qty + '\n' + url.href);
        const row = document.createElement('li');
        const title = document.createElement('span');
        title.textContent = item.title + ' — ' + item.size;
        const label = document.createElement('label');
        label.textContent = strings.quantity + ' ';
        const qty = document.createElement('input');
        qty.dataset.variant = id;
        qty.type = 'number'; qty.min = '1'; qty.max = String(item.max); qty.step = '1'; qty.value = String(item.qty);
        qty.setAttribute('aria-label', strings.quantity + ': ' + item.title + ' — ' + item.size);
        qty.addEventListener('change', () => {
          if (!whole(qty.value) || Number(qty.value) < 1 || Number(qty.value) > item.max) {
            qty.value = String(item.qty); status.textContent = strings.limit; return;
          }
          item.qty = Number(qty.value); status.textContent = ''; render(id);
        });
        const remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = strings.remove;
        remove.setAttribute('aria-label', strings.remove + ': ' + item.title + ' — ' + item.size);
        remove.addEventListener('click', () => { items.delete(id); render(); root.querySelector('[data-inquiry-count]').closest('a').focus(); });
        label.append(qty); row.append(title, label, remove); list.append(row);
      });
      root.querySelector('[data-inquiry-count]').textContent = String(total);
      root.querySelector('[data-inquiry-empty]').hidden = items.size > 0;
      summary.value = lines.length ? 'DZUBI boutique inquiry\n\n' + lines.join('\n\n') + '\n\n' + strings.total + ': ' + total : '';
      send.disabled = items.size === 0;
      if (focusId) list.querySelector('[data-variant="' + focusId + '"]')?.focus();
    }
    root.querySelectorAll('[data-add-inquiry]').forEach(button => button.addEventListener('click', () => {
      const card = button.closest('.dzubi-print');
      const inputs = [...card.querySelectorAll('[data-inquiry-quantity]')];
      const message = card.querySelector('[data-card-status]');
      const selected = inputs.filter(input => Number(input.value) > 0);
      if (inputs.some(input => !whole(input.value) || Number(input.value) > Number(input.max))) { message.textContent = strings.limit; return; }
      if (!selected.length) { message.textContent = strings.choose; return; }
      if (selected.some(input => Number(input.value) + (items.get(input.dataset.variant)?.qty || 0) > Number(input.max))) { message.textContent = strings.limit; return; }
      selected.forEach(input => {
        const previous = items.get(input.dataset.variant)?.qty || 0;
        items.set(input.dataset.variant, {title: input.dataset.title, size: input.dataset.size, url: input.dataset.url, max: Number(input.max), qty: previous + Number(input.value)});
        input.value = '0';
      });
      render(); message.textContent = strings.added;
    }));
    form.addEventListener('submit', event => {
      if (!items.size) { event.preventDefault(); status.textContent = strings.choose; return; }
      render();
    });
    render();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDzubiInquiries); else initDzubiInquiries();
document.addEventListener('shopify:section:load', initDzubiInquiries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
